import { Container, Card } from '@dma/ui';
import type { AboutContentDto } from '../application/dto/AboutContentDto';
import './MissionVision.css';

export interface MissionVisionProps {
  mission: AboutContentDto['mission'];
  vision: AboutContentDto['vision'];
}

export function MissionVision({ mission, vision }: MissionVisionProps) {
  return (
    <section className="dma-mission-vision" aria-label="مأموریت و چشم‌انداز">
      <Container>
        <div className="dma-mission-vision__grid">
          <Card>
            <h2>مأموریت</h2>
            <p>{mission}</p>
          </Card>
          <Card>
            <h2>چشم‌انداز</h2>
            <p>{vision}</p>
          </Card>
        </div>
      </Container>
    </section>
  );
}
